module.exports = __webpack_public_path__ + "img/news-eco-report.jpg?914a4ed650de81c8b284fe01c5cdbf60";